module.exports = __webpack_public_path__ + "img/grass-tile-0010.0da1d33a.jpg";